<template>
  <div class="vipService">
    <div :class="`${$root.$data.isApp || $root.$data.miniprogram ? 'isHidden' : ''}`">
      <common-title titleName="服务介绍" :zIndex="1000"></common-title>
      <div class="empty"></div>
    </div>

    <div :class="`box ${$root.$data.isApp || $root.$data.miniprogram ? '' : 'boxMini'}`">
      <div class="sidebar">
        <ul>
          <li :id="`title-${index}`" v-for="(section, index) in sections" :key="index">
            <div class="title" v-if="index === 0">课程介绍</div>
            <div class="h36" v-if="index === prepareIndex"></div>
            <div class="border" v-if="index === prepareIndex"></div>
            <div class="title1" v-if="index === prepareIndex">学员好评</div>
            <div class="subTitle" :class="{ active: currentIndex === index }" @click="scrollToSection(index)">
              {{ section.name }}
            </div>
          </li>
        </ul>
      </div>
      <div class="content-wrapper" ref="wrapper">
        <div class="content" ref="content">
          <div v-for="(section, index) in sections" :key="index" :ref="'section' + index" class="section">
            <h2 :style="{ 'padding-top': index === 0 ? 36 : 0 }"><img :src="section.icon"><span class="sectionTitle">{{
                section.name
              }}</span></h2>
            <div class="richHtml">
              <ul>
                <li v-for="item in section.desc">{{item}}</li>
              </ul>
            </div>
            <img class="content_img" :src="section.img" />
          </div>
        </div>
      </div>
    </div>
    <div class="chat" @click="openChat"></div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import {courseIntroductionSubject, ourseIntroduction} from './data'

export default {
  data() {
    return {
      sections: [],
      bs: null,
      currentIndex: 0,
    };
  },
  created() {
  },
  mounted() {
    this.$toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true,
    });
    const {subjectType} = this.$route.query;
    // 不同学科，不同的批改内容
    const obj = {
      id: 6,
      name: '1V1批改',
      desc: [],
      icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_006.png',
      img: courseIntroductionSubject[Number(subjectType)]
    }
    const temp = JSON.parse(JSON.stringify(ourseIntroduction))
    temp.splice(5, 0, obj);
    this.sections = temp;
    this.prepareIndex = 6;
    this.$nextTick(()=>{
      this.initScroll();
      this.beginListenerScroll()
    })
    this.$toast.clear();
  },
  methods: {
    async beginListenerScroll(){
      await this.$refs.wrapper.addEventListener('scroll',this.onScroll)
    },
    async stopListenerScroll(){
      await this.$refs.wrapper.removeEventListener('scroll',this.onScroll)
    },
    onScroll() {
      const sections = this.sections.map((section, index) => this.$refs[`section${index}`][0]);
      for (let i = 0; i < sections.length; i++) {
        const rect = sections[i].getBoundingClientRect();
        if (rect.top > 42 && rect.top < 70) {
          this.currentIndex = i;
        }
      }
    },
    initScroll() {
      this.scrollToSection(Number(this.$route.query.active),'timer');
      document.getElementById(`title-${this.$route.query.active}`).scrollIntoView({behavior: 'smooth'});
    },
    async scrollToSection(index,timer) {
      await this.stopListenerScroll()
      if (timer) {
        setTimeout(()=>{
          const targetElement = this.$refs[`section${index}`][0];
          targetElement.scrollIntoView({behavior: 'smooth'});
        },700)
      }else {
        const targetElement = this.$refs[`section${index}`][0];
        targetElement.scrollIntoView({behavior: 'smooth'});
      }
      this.currentIndex = index;
      const that = this;
      this.$nextTick(()=>{
        setTimeout(()=>{
          that.beginListenerScroll()
        },500)
      })
    },
    openChat() {
      let url = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=689e8f5dbce9490001a460c4';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.vipService {
  height: 100vh;
}

.empty {
  width: 100%;
  height: 100px;
}

.isHidden {
  display: none;
}

.box {
  display: flex;
  height: 100vh;
}

.boxMini {
  height: calc(100vh - 100px);
}

.sidebar {
  width: 188px;
  overflow: auto;
  background: #ffffff;

  &::-webkit-scrollbar {
    display: none;
  }
}

.sidebar ul {
  padding: 0;
  list-style: none;
}

.sidebar li {
  background: #fff;
  cursor: pointer;
}

.sidebar .title {
  padding: 54px 0 35px 36px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
  font-style: normal;
  text-align: center;
  text-align: left;
}

.sidebar .title1 {
  padding: 71px 0 35px 36px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
  font-style: normal;
  text-align: center;
  text-align: left;
}

.h36 {
  width: 100%;
  height: 36px;
}

.border {
  width: 152px;
  height: 2px;
  margin-left: 18px;
  border: 1px solid #DADADA;
}

.sidebar .subTitle {
  position: relative;
  height: 108px;
  padding-left: 36px;
  color: #999;
  font-weight: 400;
  font-size: 25px;
  font-style: normal;
  line-height: 108px;
  text-align: left;
}

.sidebar .subTitle.active {
  color: #FF7F41;
  background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/service_bg.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 188px 89px;
}

.sidebar .subTitle.active::before {
  position: absolute;
  top: 45px;
  left: 0;
  display: block;
  width: 5px;
  height: 25px;
  background: #FF7F41;
  content: '';
}

.content-wrapper {
  flex: 1;
  padding: 36px;
  overflow-y: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;    /* Firefox */
}

.content {
  //margin-top: 36px;
}

.section {
  box-sizing: border-box;
  margin-bottom: 58px;

  &:first-child {
    padding-top: 36px
  }

  &:last-child {
    padding-bottom: 36px
  }
  .content_img{
    width: 100%;
  }
}

.section h2 {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.section h2 img {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 7px;
}

.section h2 .sectionTitle {
  color: #333;
  font-weight: 500;
  font-size: 25px;
  font-style: normal;
  line-height: 36px;
  text-align: left;
}

.richHtml {
  width:100%;
  margin-bottom: 20px;
  padding-left: 30px;
  li{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    line-height: 36px;
    list-style: outside;
  }
}

.chat {
  position: fixed;
  right: 0;
  bottom: 200px;
  z-index: 10;
  width: 127px;
  height: 105px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/xuanfu_003.png');
  background-size: 100%;
}
</style>
